<div>
	<input
		matInput
		type="text"
		#autoSelectInput
		name="autoCompleteInput"
		[placeholder]="_placeholder"
		[formControl]="_control"
		[matAutocomplete]="auto"
		[maxLength]="maxLength"
		[ngClass]="{ 'custom-padding': !customPanelWidth }"
	/>
	<mat-autocomplete
		#auto="matAutocomplete"
		(optionSelected)="_optionSelected($event)"
		[panelWidth]="customPanelWidth"
		[displayWith]="_displayFn()"
		[class]="classList"
	>
		<ng-container *ngIf="_options; else observableOptions">
			<mat-option
				*ngFor="let option of _filteredOptions"
				[value]="option"
				[ngClass]="_optionClassFn(option)"
			>
				{{ _optionDisplayFn(option) }}
			</mat-option>
		</ng-container>

		<ng-template #observableOptions>
			<mat-option
				*ngFor="let option of options$ | async"
				[value]="option"
				[ngClass]="_optionClassFn(option)"
				[class.borderBottom]="
					borderBottom &&
					_optionDisplayFn(option) !== 'Enter Address Manually'
				"
			>
				<ng-container
					*ngIf="
						_optionDisplayFn(option) === 'Enter Address Manually';
						else notCustomOptions
					"
				>
					<span class="manual-address">
						<span>Can't find your address?</span>
						<span class="underline">Manual Search</span>
					</span>
				</ng-container>
				<ng-template #notCustomOptions>
					{{ _optionDisplayFn(option) }}
				</ng-template>
			</mat-option>
		</ng-template>
	</mat-autocomplete>
</div>
